// extracted by mini-css-extract-plugin
export default {"mainContainer":"OurValues_mainContainer__4ukyg","wrapper":"OurValues_wrapper__+isI8","imageContainer":"OurValues_imageContainer__jVw8k"};